<template>
  <div class="customer-detail member-detail">
    <el-container>
      <div style="margin: 20px auto 0;background: #F0F2F5;padding: 0;width: calc(100% - 40px);display: flex; justify-content: row;">
        <!--左侧-->
        <div>
        <div class="customer-left">
          <div class="main-info">
            <div class="head-img">
              <img :src="customer.avatar | showImgUrl" alt="用户头像">
            </div>
            <div class="person-info">
              <div class="user-name">{{ customer.realname }}
                <img src="../../assets/images/women.png" v-if="customer.sex === '女'" class="" />
                <img src="../../assets/images/weizhi.png" v-if="customer.sex === ''" class="" />
                <img src="../../assets/images/man.png" v-if="customer.sex === '男'" class="" />
              </div>
              <div class="phone">
                <img src="../../assets/images/icn-shouji.png" style="display: block;float: left;margin-top: 3px;margin-right: 4.5px" />
                <span v-if="customer.mobile !== ''">{{ customer.mobile }}</span>
                <span v-if="customer.mobile === '' || customer.mobile === null">暂无电话信息</span>
              </div>
              <div class="public">
                <img src="../../assets/images/icn-youxiang.png" />
                <span v-if="customer.email !== ''">{{ customer.email }}</span>
                <span v-if="customer.email === '' || customer.email === null">暂无邮件信息</span>
              </div>
            </div>
            <img src="../../assets/images/icn-binaji.png" class="edit-btn" @click="openDialog" />
          </div>
          <div class="" style="margin-top: 20px">
            <div class="title" style="margin-top: 0; text-align: left; margin-left: 18px;">标签</div>
            <div class="tag-content">
              <template>
                <div class="tags-content-look">
                  <span class="tag-span-look" :title="item" v-for="(item, index) in customer.tags" :key="index">
                    {{ item }}
                  </span>
                </div>
              </template>
            </div>
          </div>
          <!--客户详细属性-->
          <div class="person-info-title">个人资料</div>
          <div class="customer-all-info">
            <div class="info-item">
              <span>真实姓名</span><span>{{ customer.realname }}</span>
            </div>
            <div class="info-item">
              <span>性别</span><span>{{ customer.sex }}</span>
            </div>
            <div class="info-item">
              <span>会员等级</span><span>{{ memberLevelList[customer.grade] }}</span>
            </div>
            <div class="info-item">
              <span>会员积分</span><span>{{ customer.integral }}</span>
            </div>
            <div class="info-item">
              <span>当前等级</span><span>{{ customer.stage_name }}</span>
            </div>
            <div class="info-item">
              <span>微信号</span><span>{{ customer.wechat }}</span>
            </div>
            <div class="info-item">
              <span>国家</span><span>{{ customer.country_name }}</span>
            </div>
            <div class="info-item">
              <span>省份</span><span>{{ customer.province_name }}</span>
            </div>
            <div class="info-item">
              <span>城市</span><span>{{ customer.city_name }}</span>
            </div>
            <div class="info-item">
              <span>区县</span><span>{{ customer.district_name }}</span>
            </div>
            <div class="info-item">
              <span>初始来源</span><span>{{ customer.source }}</span>
            </div>
            <!-- <div class="info-item">
              <span>创建方式</span><span>{{ customer.create_type }}</span>
            </div> -->
            <div class="info-item">
              <span>手机号</span><span>{{ customer.mobile }}</span>
            </div>
            <div class="info-item">
              <span>手机号验证</span><span>{{customer.mobile_verified}}</span>
            </div>
            <div class="info-item">
              <span>座机号</span><span>{{ customer.phone }}</span>
            </div>
            <div class="info-item">
              <span>邮箱</span><span>{{ customer.email }}</span>
            </div>
            <div class="info-item">
              <span>邮箱验证</span><span>{{customer.email_verified}}</span>
            </div>
            <div class="info-item">
              <span>生日</span><span>{{ customer.birthday }}</span>
            </div>
            <div class="info-item">
              <span>家庭住址</span><span>{{ customer.home_address }}</span>
            </div>
            <div class="info-item">
              <span>公司名称</span><span>{{ customer.company }}</span>
            </div>
            <div class="info-item">
              <span>公司地址</span><span>{{ customer.company_address }}</span>
            </div>
            <div class="info-item">
              <span>备注</span><span>{{ customer.remark }}</span>
            </div>
            <div class="info-item">
              <span>行业</span><span>{{ customer.industry }}</span>
            </div>
            <div class="info-item">
              <span>职位</span><span>{{ customer.position }}</span>
            </div>
            <div class="info-item">
              <span>身份证号</span><span>{{ customer.id_number }}</span>
            </div>
            <div class="info-item" :title="customer.nickname">
              <span>昵称</span><span>{{ customer.nickname }}</span>
            </div>
            <div class="info-item">
              <span>QQ</span><span>{{ customer.qq }}</span>
            </div>
            <div class="info-item">
              <span>是否本公司员工</span><span v-if="customer.self_company === 0">否</span><span v-if="customer.self_company === 1">是</span>
            </div>
            <div class="info-item">
              <span>创建时间</span><span>{{ customer.create_time | formatDate }}</span>
            </div>
            <div class="info-item">
              <span>最后修改时间</span><span>{{ customer.update_time | formatDate }}</span>
            </div>
            <div class="info-item" :key="index" v-for="(attr, index) in attributeList" v-if="attr.is_system == 0">
              <span>{{attr.name}}</span><span>{{ customer[attr.identity] | diyAttr }}</span>
            </div>
          </div>
          <div class="customer-info">
            <div class="customer-info-item">
              <span style="font-size:14px;margin-bottom:-10px" v-if="customerInfo.length>0">客户身份</span>
            </div>
            <div class="info-group" style="margin:20px" v-for="(item, index) in customerInfo" :key="index">
              <div class="weixin-img">
                <img src="../../assets/images/weixin-1.png" alt="客户图片" v-if="item.type === 'wechat'">
                <img src="../../assets/images/weixin-3.png" alt="客户图片" v-if="item.type === 'wechat_unionid'">
              </div>
              <div class="person-info-margin">
                <div class="info-message" :title="item.public_name">
                  <span v-if="item.type === 'wechat'">身份信息：<span>微信open ID</span> ({{ item.public_name }})</span>
                  <span v-if="item.type === 'wechat_unionid'">身份信息：<span>微信unionid</span> ({{ item.public_name }})</span>
                </div>
                <div class="info-message" :title="customerType[item.type]">
                  <span>身份类型：{{ customerType[item.type] }}</span>
                </div>
                <div class="info-message" :title="item.value">
                  <span>身份ID：{{ item.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <!--右侧-->
        <div class="customer-right">
          <!--等级和活跃度-->
          <div class="score-stage">
            <div class="stage">
              <div class="stage-icon">
                <img src="../../assets/images/icon-time.png" alt="等级图片">
              </div>
              <div class="stage-content">
                <div class="stage-day">
                  <p>接触时间</p>
                  <p><span>{{ customer.days }}天</span></p>
                </div>
                <div class="stage-now">
                  <p>会员等级</p>
                  <p><span>{{ memberLevelList[customer.grade] }}</span></p>
                </div>
                <div class="stage-now">
                  <p>会员积分</p>
                  <p><span>{{ customer.integral }}</span></p>
                </div>
              </div>
            </div>
            <div class="score">
              <div class="score-icon">
                <img src="../../assets/images/group3.png" alt="积分图片">
              </div>
              <div class="score-all score-item">
                <p>会员价值评分</p>
                <p><span>{{ customer.empirical+customer.gold_score }}</span></p>
              </div>
              <div class="score-item">
                <p>&nbsp;&nbsp;</p>
                <p>=</p>
              </div>
              <div class="score-datum score-item">
                <p>资料评分</p>
                <p><span>{{ customer.gold_score }}</span></p>
              </div>
              <div class="score-item">
                <p>&nbsp;&nbsp;</p>
                <p>+</p>
              </div>
              <div class="score-liveness score-item">
                <p>活跃度</p>
                <p><span>{{ customer.empirical }}</span></p>
              </div>
            </div>
          </div>
          <!--时间轴订单以及收货地址-->
          <div class="bottom-content">
            <div class="tabs">
              <div :key="index" v-for="(item, index) in tabs" class="tab-item" @click="changeTabs(index)">
                <span class="timeline-nav-name" :class="tabIndex == index ? 'active' : ''">{{ item.name }}</span>
              </div>
            </div>
            <div class="tab-contents">
              <div v-if="tabIndex === 0">
                <!--<div class="search-record">-->
                  <!--<div class="record">记录事件</div>-->
                  <!--<div class="search">-->
                    <!--<i class="el-icon-search"></i>筛选-->
                  <!--</div>-->
                <!--</div>-->
                <div class="time-line" style="padding-bottom: 20px">
                  <div class="day-item" v-for="(item, index) in timeLine" :key="index">
                    <div class="day-title-content clearfloat">
                      <div class="day-title" @click="closeDay(index)">
                        {{ item.dayName }}
                        <i class="el-icon-arrow-right" v-if="item.close === false"></i>
                        <i class="el-icon-arrow-down" v-if="item.close === true"></i>
                      </div>
                      <div class="" :class="item.close === true ? 'day-item-smalls' : 'day-item-small'">
                        <div class="time-line-circle"></div>
                        <div v-if="item.close === false" class="total-event">
                          <div :key="j" v-for="(totalItem, j) in item.totalThings">
                            <img :src="totalItem.event_icon | showImgUrl" style="width: 16px;height: 16px;border-radius: 50%;margin: 0;vertical-align: middle;display: inline-block; margin-right: 5px;">{{ totalItem.event_name }}x{{ totalItem.event_num }}
                          </div>
                          <span class="arrow-left-close"></span>
                        </div>
                      </div>
                    </div>
                    <div :key="i" v-if="item.close === true" class="time-item" v-for="(one, i) in item.dayThings" :class="one.event_identity === 'system' ? 'type-two' : 'type-one'">
                      <div v-if="one.join_date !== 0" class="real-time">{{ one.join_date | formatTime }}</div>
                      <div v-if="one.join_date == 0" class="real-time">{{ one.create_time | formatTime }}</div>
                      <div class="type-show" :class="one.event_identity === 'system' ? 'type-two type-img' : 'type-one'">
                        <div class="type-show-line">
                          <img :src="one.icon | showImgUrl" alt="" style="border-radius: 50%">
                          <div class="small-line"></div>
                        </div>
                      </div>
                      <div class="things-content" :class="one.event_identity === 'system' ? 'type-two type-spe' : 'type-one'">
                        <div>
                          <p class="content-title">{{ one.title }}</p>
                          <p class="content-content">{{ one.content }}</p>
                        </div>
                        <div v-if="one.event_identity !== 'system'" class="score-content">
                          <span v-if="one.score > 0">
                             <span><img src="../../assets/images/Shape.png" alt="活跃度" style="margin:0 5px">
                          </span>+</span>{{ one.score }}
                        </div>
                        <div v-if="one.event_identity === 'system'" class="system-event">
                          <i class="iconfont icon-icon-shebeixinxi1" title="系统事件"></i>
                        </div>
                        <div class="arrow-left"></div>
                      </div>
                      <div class="clearfloat"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="tabIndex === 1">
                <div class="order-item" :key="index" v-for="(item, index) in orderList">
                  <div class="order-item-info">
                    <div class="order-time" style="cursor: pointer" @click="closeOrders(index)">
                      {{ item.createtime }}
                      <i class="el-icon-arrow-right" v-if="item.close === false"></i>
                      <i class="el-icon-arrow-down" v-if="item.close === true"></i>
                    </div>
                    <div class="order-main-info">
                      <div class="order-store">
                        {{ item.shop_name }}&nbsp;
                        <span>订单号:{{ item.code }}</span>
                      </div>
                      <div class="order-money">
                        {{ item.lines.length }}款商品合计 ￥{{ item.payment }}
                      </div>
                    </div>
                  </div>
                  <div class="order-goods-info" v-if="item.close === false" :key="i" v-for="(one, i) in item.lines">
                    <div class="goods-left" style="float: left"></div>
                    <div class="goods-main-info">
                      <div style="float: left">{{ one.item_name }}</div>
                      <div class="goods-price">
                        <span>单价￥{{ one.price }}</span>&nbsp;&nbsp;&nbsp;
                        <span>x{{ one.qty }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="tabIndex === 2">
                <div class="adress-item" :key="index" v-for="(item, index) in adressList">
                  <el-form :inline="true" class="adress-content-item" label-width="55px">
                    <el-form-item label="省:">
                      {{ item.consignee_province }}
                    </el-form-item>
                    <el-form-item label="市:">
                      {{ item.consignee_city }}
                    </el-form-item>
                    <el-form-item label="区:">
                      {{ item.consignee_county }}
                    </el-form-item>
                  </el-form>
                  <el-form :inline="true" class="adress-content-item" label-width="100px">
                    <el-form-item label="详细地址:">
                      {{ item.consignee_address }}
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-container>
      <!--编辑客户详情的弹窗-->
      <el-dialog class="cellDialog base-dialog edit-customer-detail" title="编辑会员" :visible.sync="adddialog" width="580px">
        <el-form ref="addForm" :model="addForm" style="height: 400px;overflow: auto;">
          <el-form-item label="地区"
                        :label-width="addLabelWidth">
            <el-cascader
                    size="large"
                    :options="regionData"
                    v-model="customer.sysAddressPcd"
                    >
            </el-cascader>
          </el-form-item>
          <!--排除省市区-->
          <el-form-item
            :label="attr.name + ':'"
            :label-width="addLabelWidth"
            :key="index" v-for="(attr, index) in attributeList"
            v-if="attr.name.length < 6 && (attr.identity != 'province' && attr.identity != 'city' && attr.identity != 'district' && attr.identity != 'country_id')">
            <diy-attribute
              :key="index"
              :type="attr.type"
              v-model="customer[attr.identity]"
              :option='attr.option'>
            </diy-attribute>
          </el-form-item>
          <el-form-item
            class="long-text"
            :label="attr.name + ':'"
            :label-width="addLabelWidth"
            :key="index" v-for="(attr, index) in attributeList"
            v-if="attr.name.length >= 6 && (attr.identity != 'province' && attr.identity != 'city' && attr.identity != 'district' && attr.identity != 'country_id')">
            <diy-attribute
              :key="index"
              :type="attr.type"
              v-model="customer[attr.identity]"
              :option='attr.option'>
            </diy-attribute>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top: 10px">
          <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
          <el-button class="dialog-confirm-btn" type="primary" @click="updateCustomer">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { getCustomerDetailTimeline, getCustomerDetailItems, getCustomerStage, getCustomerAttributeList, editCustomer, getGroupById, getMemberLevelList, getCustomerOrderList, getMemberDetailsReceiveAdress, getCustomerIdMessage } from '@/api/customer.js'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import DiyAttribute from '@/components/common/diy-attribute'
export default {
  name: 'customerDetail',
  data () {
    return {
      orderList: [],
      regionData: regionData,
      selectedOptions: [],
      stages: [],
      stage: '',
      adddialog: false,
      addForm: {
        name: '',
        phone: '',
        sex: 1,
        mobile_verified: 1,
        niceName: '',
        stage_id: '',
        province: '',
        district: '',
        city: '',
        mobile: '',
        email: '',
        email_verified: 1,
        birthday: ''
      },
      addLabelWidth: '110px',
      intelligentData: [],
      aiGroup: [],
      aiGroupOptions: [],
      value4: [],
      tabs: [
        {
          icon: 'el-icon-share',
          name: '时间轴'
        },
        {
          icon: 'el-icon-goods',
          name: '订单'
        },
        {
          icon: 'el-icon-location',
          name: '收货地址'
        }
      ],
      tabIndex: 0,
      timeLine: [],
      timeLineTotal: [],
      // 属性列表
      attributeList: [],
      // 客户属性
      customer: {
        avatar: ''
      },
      memberLevelList: [],
      adressList: [],
      customerInfo: [],
      customerType: {
        wechat: 'openid',
        wechat_unionid: 'unionid'
      }
    }
  },
  filters: {
    diyAttr(value) {
      if (!Array.isArray(value)) {
        return value
      }
      return value.toString()
    }
  },
  components: {
    'diy-attribute': DiyAttribute
  },
  methods: {
    // 关闭订单
    closeOrders(index) {
      if (this.orderList[index].close === false) {
        this.orderList[index].close = true
      } else {
        this.orderList[index].close = false
      }
    },
    // 处理地址
    handleChange() {},
    // 获取客户等级
    getCustomerStages() {
      getCustomerStage().then((res) => {
        if (res.data.code === 0) {
          this.stages = res.data.data
        }
      })
    },
    // 打开编辑弹窗
    openDialog() {
      this.adddialog = true
      this.getCustomerStages()
    },
    // 弹窗确定
    updateCustomer() {
      this.customer.province = this.customer.sysAddressPcd[0]
      this.customer.city = this.customer.sysAddressPcd[1]
      this.customer.district = this.customer.sysAddressPcd[2]
      editCustomer(this.customer).then(res => {
        if (res.data.code == 0) {
          this.load()
          this.adddialog = false
          _g.toastMsg('success', '更新成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 右侧选项卡
    changeTabs(index) {
      this.tabIndex = index
    },
    // 开关时间轴的日期
    closeDay(index) {
      if (this.timeLine[index].close === false) {
        this.timeLine[index].close = true
      } else {
        this.timeLine[index].close = false
      }
    },
    // 加载时间轴数据
    loadTimeline () {
      let id = this.$route.query.id
      getCustomerDetailTimeline(id).then((res) => {
        for (let item of res.data.data.list) {
          item.close = false
        }
        this.timeLine = res.data.data.list
      })
    },
    // 获取所有属性列表
    getCustomerAttributeList() {
      getCustomerAttributeList().then(res => {
        this.attributeList = res.data.data
        console.log('this.attributeList', this.attributeList)
      }).catch(error => {
        console.log(error)
      })
    },
    // 获取用户的身份信息
    getCustomerIdentity() {
      let id = this.$route.query.id
      getCustomerIdMessage(id).then(res => {
        if (res.data.code == 0) {
          console.log(res, 'qqqq')
          this.customerInfo = res.data.data.list
        }
      })
    },
    load() {
      let id = this.$route.query.id
      // 获取所有属性列表
      let attrPro = getCustomerAttributeList()
      // 获取客户详情
      let customerPro = getCustomerDetailItems(id)
      // 获取订单列表
      let orders = getCustomerOrderList(id)
      Promise.all([attrPro, customerPro, orders]).then(res => {
        let attrList = res[0].data.data
        let customer = res[1].data.data
        // 请求地址
        this.getAdress()
        if (customer.birthday === '1970-01-01' || customer.birthday === '1900-01-01' || customer.birthday === '0000-00-00') {
          customer.birthday = '未知'
        }
        if (customer.country_name === '') {
          customer.country_name = '中国'
        }
        // 排序
        attrList.sort(function(obj1, obj2) {
          let val1 = obj1.sort
          let val2 = obj2.sort
          if (val1 < val2) {
            return -1
          } else if (val1 > val2) {
            return 1
          } else {
            return 0
          }
        })
        console.log('attrList', attrList)
        for (let item of attrList) {
          if (typeof customer[item.identity] === 'undefined') {
            if (item.type === 'checkBox') {
              customer[item.identity] = []
            } else {
              customer[item.identity] = null
            }
          }
        }
        customer.sysAddressPcd = [customer.province + '', customer.city + '', customer.district + '']
        this.attributeList = attrList
        this.customer = customer
        for (var i = 0; i < this.attributeList.length; i++) {
          if (this.attributeList[i].identity === 'stage_id') {
            this.attributeList.splice(i--, 1)
          }
          if (this.attributeList[i].identity === 'country') {
            this.attributeList.splice(i--, 1)
          }
          if (this.attributeList[i].identity === 'is_vip') {
            this.attributeList.splice(i--, 1)
          }
          if (this.attributeList[i].identity === 'source_id') {
            this.attributeList.splice(i--, 1)
          }
          if (this.attributeList[i].identity === 'create_time') {
            this.attributeList.splice(i--, 1)
          }
          if (this.attributeList[i].identity === 'update_time') {
            this.attributeList.splice(i--, 1)
          }
        }
        // 处理订单
        if (res[2].data.code === 0) {
          for (let item of res[2].data.data.list) {
            item.close = false
          }
          this.orderList = res[2].data.data.list
          console.log('ss', this.orderList)
        }
      })
    },
    getCustomerGroupById() {
      let id = this.$route.query.id
      getGroupById(id).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          for (var i = res.data.data.dynamic_list.length - 1; i >= 0; i--) {
            this.intelligentData.push({
              value: res.data.data.dynamic_list[i].query_id,
              label: res.data.data.dynamic_list[i].query_name
            })
          }
          for (var j = res.data.data.static_list.length - 1; j >= 0; j--) {
            this.aiGroupOptions.push({
              value: res.data.data.static_list[j].query_id,
              label: res.data.data.static_list[j].query_name
            })
          }
          for (let item of this.intelligentData) {
            this.aiGroup.push(item.label)
          }
          for (let item of this.aiGroupOptions) {
            this.value4.push(item.label)
          }
        }
      })
    },
    getMemberLevel() {
      getMemberLevelList(1, {}).then(res => {
        for (let i in res.data.data.list) {
          let item = res.data.data.list[i]
          this.memberLevelList[item.id] = item.level_title
        }
        this.load()
      })
    },
    getAdress() {
      let id = this.$route.query.id
      getMemberDetailsReceiveAdress(id).then(res => {
        this.adressList = res.data.data.list
        console.log('this.adressList', this.adressList)
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/home/customer-manage') {
      to.meta.keepAlive = true
      console.log(to.meta.keepAlive)
    } else {
      to.meta.keepAlive = false
    }
    next()
  },
  created() {
    this.getMemberLevel()
    this.loadTimeline()
    this.getCustomerGroupById()
    this.getCustomerIdentity()
  }
}
</script>

<style scoped>
  .info-group {
    height:100px;
    background:#e7e7e7;
  }
  .weixin-img{
    width: 72px;
    height: 100%;
    float: left;
    display: flex;
    justify-content: center;
  }
  .weixin-img img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: block;
    margin-top: 25px;
  }
  .info-message{
    font-size: 12px;
    font-weight: 400;
    color:#333;
    line-height: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .customer-info {
    min-width: 260px;
    padding-top:12px;
    background: #fff;
    position: relative;
    width: 30%;
  }
  .person-info-margin {
    width: calc(100% - 72px);
    float: left;
    text-align: left;
    box-sizing: border-box;
    margin:14px auto;
    color:#f5f7fa;
  }
  .customer-info-item {
    width: calc(100% - 46px);
    margin: 0 auto;
    color: #333;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    border-bottom: none;
  }
  @media only screen and (max-width: 1450px) {
    .stage .stage-icon {
      width: 50px;
      height: 50px;
      margin-left: 5px;
    }
    .score .score-icon {
      width: 50px;
      height: 50px;
      margin-left: 5px;
    }
    .score-stage .stage p, .stage .stage-now p span, .stage .stage-day p span {
      font-size: 12px;
      margin-left: 4px;
    }
    .score .score-item p span {
      font-size: 14px;
    }
    .stage .stage-day, .stage .stage-now {
      display: flex;
      flex-direction: row;
    }
    .score-stage .stage-content {
      display: flex;
      flex-direction: column;
    }
    .score-stage .stage {
      width: 45%;
      display: flex;
      flex-direction: row;
    }
    .score-stage .score{
      width: calc(55% - 20px);
    }
  }
  .stage-content {
    display: flex;
    flex-direction: row;
  }
  .person-info-title{
    font-size: 14px;
    color: #333;
    margin-top: 21px;
    text-align: left;
    padding-left: 18px;
    font-weight: bold;
  }
  .goods-price{
    float: right;
  }
  .goods-left{
    width: 25%;
    height: 50px;
  }
  .order-item{
    width: 100%;
    height: auto;
    line-height: 50px;
  }
  .order-item-info{
    width: 100%;
    height: 50px;
    color: #666;
  }
  .order-time{
    width: 25%;
    float: left;
    height: 50px;
  }
  .order-main-info{
    width: 71%;
    float: left;
    height: 50px;
    padding: 0 2%;
  }
  .goods-main-info{
    float: right;
    width: 69%;
    height: 50px;
    padding: 0 2%;
    background: #ECF0F7;
    margin-right: 2%;
  }
  .order-store{
    float: left;
  }
  .order-money{
    float: right;
  }
  .order-goods-info{
    width: 100%;
    height: 50px;
    margin-bottom: 10px;
    color: #999;
    font-size: 14px;
  }
  ::-webkit-scrollbar
  {
    width: 6px;  /*滚动条宽度*/
    height: 16px;  /*滚动条高度*/
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track
  {
    box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    border-radius: 10px;  /*滚动条的背景区域的圆角*/
    background-color: #f5f5f5;/*滚动条的背景颜色*/
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb
  {
    border-radius: 10px;  /*滚动条的圆角*/
    box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #ccc;  /*滚动条的背景颜色*/
  }
  .el-radio-group{
    margin-top: -13px;
  }
  .text-align-left {
    text-align: left;
  }
  .customer-left{
    width: 260px;
    /* width: 30%; */
    background: #fff;
    padding-bottom: 5px;
    border: 1px solid #E7E9F0;
    border-bottom: none;
  }
  .main-info {
    min-width: 240px;
    margin: 0 auto;
    height: 140px;
    border-bottom: 1px solid #DEDEDE;
    background: #fff;
    position: relative;
  }
  .edit-btn{
    display: block;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 13px;
    right: 3px;
    cursor: pointer;
    background: none;
    padding: 0;
    margin-right: 15px;
  }
  .edit-btn:hover {
    background-color: #fff;
  }
  .head-img{
    width: 96px;
    height: 100%;
    float: left;
    display: flex;
    justify-content: center;
  }
  .head-img img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: block;
    margin-top: 33px;
  }
  .person-info{
    width: calc(100% - 96px);
    float: left;
    height: 100%;
    text-align: left;
  }
  .user-name{
    font-size: 18px;
    color: #333;
    margin-top: 29px;
    font-weight: bold;
  }
  .phone{
    margin-top: 12px;
  }
  .public{
    margin-top: 10px;
  }
  .phone,.public{
    font-size: 14px;
    color: #333;
  }
  .intelligent .title, .intelligent-special .title{
    height: 20px;
    line-height: 20px;
    color: #333;
    font-weight: bold;
    font-size: 14px;
    text-align: left;
    margin-left: 18px;
    margin-top: 27px;
  }
  .intelligent .content, .intelligent-special .content{
    line-height: 34px;
    color: #333;
    font-size: 16px;
    text-align: left;
    margin-left: 18px;
    margin-top: 8px;
  }
  .customer-all-info{
    height: 1000px;
    overflow: auto;
    margin-top: 10px;
  }
  .info-item{
    width: calc(100% - 46px);
    margin: 0 auto;
    height: 36px;
    line-height: 36px;
    color: #333;
    font-size: 12px;
    border-bottom: 1px solid #E7E7E7;
    display: flex;
    justify-content: space-between;
  }
  .info-item>span {
    min-width: 25px;
  }
  .info-item span:nth-child(2){
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .info-item span:first-child{
    color: #666;
    font-size: 12px;
  }
  .customer-right{
    margin-left: 20px;
    width: calc(100% - 40px);
  }
  .score-stage{
    width: 100%;
    height: 140px;
  }
  .stage{
    width: 40%;
    height: 140px;
    float: left;
    background: #fff;
    border: 1px solid #E7E9F0;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .stage-icon{
    width: 80px;
    height: 80px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 80px;
    border-radius: 0;
  }
  .stage-icon img{
    width: 100%;
    display: block;
    height: 100%;
  }
  .stage-day p,.stage-now p{
    color: #999;
    font-size: 14px;
  }
  .stage-day p span{
    color: #333;
    font-size: 16px;
    font-weight: bold;
  }
  .stage-now p span{
    color: #F8A136;
    font-size: 16px;
    font-weight: bold;
  }
  .score{
    width: calc(60% - 20px);
    height: 140px;
    float: right;
    background: #fff;
    border: 1px solid #E7E9F0;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .score-icon{
    width: 80px;
    height: 80px;
    border-radius: 0;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 80px;
  }
  .score-icon img{
    width: 100%;
    display: block;
    height: 100%;
  }
  .score-item p{
    color: #999;
    font-size: 14px;
  }
  .score-item p span{
    color: #333;
    font-size: 20px;
    font-weight: bold;
  }
  .thirty-liveness{
    position: relative;
  }
  .line{
    width: 1px;
    height: 80px;
    background: #E7E7E7;
  }
  .bottom-content{
    margin-top: 20px;
    background: #fff;
    border: 1px solid #E7E9F0;
  }
  .tabs{
    width: 100%;
    height: 40px;
    margin-top: 10px;
    border-bottom: 1px solid #E7E9F0;
  }
  .tabs .tab-item{
    width: 180px;
    height: 40px;
    float: left;
    margin-right: 6px;
    background: #fff;
    color: #8E919D;
    line-height: 38px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
  .tab-contents{
    background: #fff;
    margin-top: 10px;
    padding-bottom: 20px;
  }
  .tabs .active{
    background: #fff;
    color: #1890FF;
    border-bottom: 2px solid #1890FF;
  }
  .timeline-nav-name{
    width: 80px;
    height: 40px;
    line-height: 40px;
    display: block;
    margin: 0 auto;
  }
  .search-record{
    height: 30px;
    line-height: 30px;
    color: #60C6CF;
    font-size: 14px;
    padding-top: 10px;
  }
  .search{
    width: 60px;
    height: 20px;
    margin-top: 5px;
    line-height: 20px;
    float: right;
    margin-right: 10px;
    border-right: 1px solid #ccc;
    cursor: pointer;
  }
  .record{
    float: right;
    cursor: pointer;
    margin-right: 10px;
  }
  .day-title-content{
    width: 90%;
    margin: 0 auto;
  }
  .day-title{
    width: 120px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    color: #000;
    float: left;
    background: #fff;
    border-radius: 3px;
    cursor: pointer;
  }
  .day-title i{
    color: #000;
  }
  .day-line{
    width: 2px;
    height: 40px;
    background: #E7E7E7;
    position: absolute;
    bottom: -80%;
    left: 13px;
    margin-left: -7px;
    margin-bottom: -7px;
  }
  .total-event{
    /*width: calc(100% - 220px);*/
    height: auto;
    background: #F0F3F6;
    float: left;
    margin-left: 50px;
    display: flex;
    /*justify-content: space-between;*/
    align-items: center;
    flex-wrap: wrap;
    position: relative;
  }
  .total-event div{
    width: 180px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #666;
    text-align: left;
    padding-left: 20px;
  }
  .day-item-small{
    width: calc(100% - 161px);
    height: auto;
    float: left;
    margin-left: 39px;
    padding-bottom: 10px;
    position: relative;
    border-left: 2px solid #E7E7E7;
  }
  .day-item-smalls{
    width: calc(100% - 161px);
    height: auto;
    float: left;
    margin-left: 39px;
    padding-bottom: 30px;
    position: relative;
    border-left: 2px solid #E7E7E7;
  }
  .time-line-circle{
    width: 12px;
    height: 12px;
    background: #E7E7E7;
    position: absolute;
    left: -7px;
    top: 8px;
    border-radius: 50%;
  }
  .time-item{
    width: 90%;
    margin:0 auto 20px;
    height: 100%;
  }
  .clearfloat{
    clear: both;
  }
  .real-time{
    font-size: 14px;
    color: #808491;
    width: 120px;
    float: left;
    height: 30px;
    margin-top: 20px;
    line-height: 30px;
    text-align: right;
  }
  .type-show{
    width: 80px;
    float: left;
  }
  .type-one{
    height: 80px;
  }
  .type-two{
    height: 80px;
  }
  .type-spe p:first-child{
    margin-top: 20px;
  }
  .type-spe .arrow-left{
    top: 10px;
  }
  .arrow-left-close{
    display: block;
    position: absolute;
    height: 0px;
    width: 0px;
    border-top: 9px solid transparent;
    border-right: 10px solid #F5F5F5;
    border-bottom: 10px solid transparent;
    left: -10px;
    top: 7px;
  }
  .type-img .type-show-line img{
    top: 0;
  }
  .type-show-line{
    width: 2px;
    height: 100%;
    background: #E7E7E7;
    position: relative;
    margin: 0 auto;
  }
  .small-line{
    width: 2px;
    height: 20px;
    background: #E5E5E5;
    position: absolute;
    bottom: -20px;
    left: 50%;
    margin-left: -1px;
    z-index: 200;
  }
  .type-show-line img{
    position: absolute;
    display: block;
    top:20px;
    left: 50%;
    width: 40px;
    margin-left: -20px;
    z-index: 2;
    background:#fff;
  }
  .things-content{
    width: calc(100% - 200px);
    float: left;
    background: #F0F3F6;
    display: flex;
    justify-content: space-between;
    position: relative;
  }
  .arrow-left{
    position: absolute;
    height: 0px;
    width: 0px;
    border-top: 9px solid transparent;
    border-right: 10px solid #F5F5F5;
    border-bottom: 10px solid transparent;
    left: -10px;
    top: 30px;
  }
  .content-title{
    font-size: 14px;
    color: #333;
    text-align: left;
    margin-left: 20px;
    line-height: 20px;
    margin-top: 18px;
    margin-bottom: 5px;
  }
  .content-content{
    font-size: 12px;
    color: #666;
    text-align: left;
    margin-left: 20px;
    line-height: 20px;
    margin-top: 6px;
  }
  .score-content{
    font-size: 14px;
    color: #333;
    text-align: center;
    margin: 10px 12px 0 0;
  }
  .system-event{
    padding: 0 10px;
    font-size: 14px;
    color: #059BAA;
    height: 30px;
    line-height: 30px;
    text-align: center;
    margin: 10px 10px 0 0;
    border-radius: 3px;
  }
  .adress-content-item {
    margin-bottom: 0px;
    text-align: left;
    margin-left: 20px;
    font-size: 18px;
    color: #333;
    height: 50px;
  }
  .adress-item {
    margin-bottom: 10px;
    border: 1px solid #dedede;
    margin-left: 10px;
    margin-right: 10px;
    color: #333;
  }
  .adress-item .el-form-item {
    margin-bottom: 0px;
  }
  .tag-content {
  margin-left: 15px;
  margin-right: 15px;
  max-width: 230px;
}
.tag-span-look {
  display: inline-block;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 5px;
  height: 20px;
  line-height: 20px;
  padding: 5px;
  margin: 5px;
  color: #c0c4cc;
  overflow:hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}
.tags-content-look {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
